import { useSelector } from 'react-redux';
import { ThemeProvider, useTheme } from '@mui/material/styles';
import { selectContrastMainTheme } from 'app/store/core/settingsSlice';
import clsx from 'clsx';
import WdScrollbars from '../WdScrollbars';

function WdPageSimpleSidebarContent(props) {
  const theme = useTheme();
  const contrastTheme = useSelector(selectContrastMainTheme(theme.palette.primary.main));

  return (
    <WdScrollbars enable={props.innerScroll}>
      {props.header && (
        <ThemeProvider theme={contrastTheme}>
          <div className={clsx('FusePageSimple-sidebarHeader', props.variant)}>{props.header}</div>
        </ThemeProvider>
      )}

      {props.content && <div className="FusePageSimple-sidebarContent">{props.content}</div>}
    </WdScrollbars>
  );
}

export default WdPageSimpleSidebarContent;
